import { render, staticRenderFns } from "./Bubble8.vue?vue&type=template&id=8f1f1804"
import script from "./Bubble8.vue?vue&type=script&lang=js"
export * from "./Bubble8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports